var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -3646.25,
    y1: 2270.75,
    x2: -3646.25,
    y2: 2305.75,
    gradientTransform: "translate(-2270.75 3663.74) rotate(90) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#12338a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#173f94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#265fb0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#3d92dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4fb8ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 17.5,
    cy: 17.5,
    r: 17.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.84,26.47c3.72,0,6.71-2.23,8.08-5.11.11-.23.01-.5-.22-.61-.23-.11-.5-.01-.61.22-1.33,2.79-4.18,4.59-7.26,4.59-4.44,0-8.05-3.61-8.05-8.05s3.61-8.05,8.05-8.05c3.08,0,5.92,1.8,7.26,4.59.11.23.38.32.61.22s.32-.38.22-.61c-1.35-2.82-4.31-5.11-8.08-5.11-4.94,0-8.97,4.02-8.97,8.97s4.02,8.97,8.97,8.97ZM26.62,20.28c-.18.18-.18.47,0,.65.19.19.48.17.65,0l3.11-3.11c.18-.18.18-.47,0-.65l-3.11-3.11c-.18-.18-.47-.18-.65,0-.18.18-.18.47,0,.65l2.33,2.33h-6.86c-.25,0-.46.21-.46.46s.21.46.46.46h6.86l-2.33,2.33Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.d1a9b305667c93c897a7435f67e63c38.svg";
export { ForwardRef as ReactComponent };